import React, { useState } from "react";
import classNames from "classnames";
import { Fade } from "../Transitions";
import { AlertProps } from "./PropsType";

export default function Alert(props: AlertProps) {
  const {
    className,
    showIcon,
    prefixCls = "bm-Alert",
    desc,
    closable,
    icon,
    banner,
    title,
  }: any = props;
  let alertIcon = icon;
  let type = props.type || "info";
  const [closed, setClosed] = useState(false);

  const close = () => {
    setClosed(true);
  };

  if (!icon && type) {
    switch (type) {
      case "info":
        alertIcon = "error_outline";
        break;
      case "success":
        alertIcon = "check_circle_outline";
        break;
      case "warning":
        alertIcon = "error_outline";
        break;
      case "error":
        alertIcon = "highlight_off";
        break;
    }
  }

  if (banner) {
    alertIcon = "error_outline";
    type = "warning";
  }

  const styleClass = classNames(
    prefixCls,
    `${prefixCls}-${type}`,
    {
      [`${prefixCls}-with-icon`]: alertIcon,
      [`${prefixCls}-with-desc`]: desc,
      [`${prefixCls}-with-close`]: closable,
    },
    className
  );

  const elem = closed ? null : (
    <Fade in={!closed}>
      <div className={styleClass}>
        {showIcon && alertIcon ? (
          <span>
            <i className="bm-Icon bm-Alert-icon">{alertIcon}</i>
          </span>
        ) : null}
        <div className={`${prefixCls}-body`}>
          <span className={`${prefixCls}-title`}>{title}</span>
          {desc ? <span className={`${prefixCls}-desc`}>{desc}</span> : null}
        </div>
        {closable ? (
          <span className={`${prefixCls}-close`} onClick={close}>
            <i className="bm-Icon">clear</i>
          </span>
        ) : null}
      </div>
    </Fade>
  );
  return elem;
}
